export default "__VITE_ASSET__CcLwsT2D__"